/* eslint-disable quotes */
import runtimeEnv from "./runtime-env";

const AppConstants = {
  baseURL: runtimeEnv.API_URL,
  user: {
    Id: "1",
    firstName: "Sample",
    lastName: "Sample",
    designation: "_",
  },
  isTempHidden: true,
  scwDataPointLimit: Number.MAX_SAFE_INTEGER,
  parametricBoxPlotDiesShowingLimit: 20000,
  STEP_INTAKE_RETRY_TIME_IN_MINUTES: 45,
  DATA_INTAKE_RETRY_TIME_IN_MINUTES: 45,
  numberOfGraphsPerRow: 5,
  ALLOW_REPORTS_RETRIEVAL_BATCHING: true,
};

export const reticlePlotSequenceOptions = [
  ["HORIZONTAL_LEFT_TO_RIGHT", "Horizontal Left to Right"],
  ["HORIZONTAL_RIGHT_TO_LEFT", "Horizontal Right to Left"],
  ["VERTICAL_RIGHT_TO_LEFT", "Vertical Right to Left"],
  ["VERTICAL_LEFT_TO_RIGHT", "Vertical Left to Right"],
];

export default AppConstants;
